import { SkeletonLoader } from "@pepperstone/pepper-ui-kit";
import styles from "./SkeletonLoadingScreen.module.css";

export const SkeletonLoadingScreen = () => {
  return (
    <div
      className={`ps-flex ps-flex-col ps-flex-1 ${styles.skeletonLoadingScreen}`}
    >
      <div className="ps-flex ps-flex-row ps-mb-8">
        <SkeletonLoader height={12} width={40} variant="rectangular" />
      </div>
      <div className="ps-flex ps-flex-row ps-mb-8 ps-gap-4">
        <SkeletonLoader height={6} width={12} variant="rectangular" />
        <SkeletonLoader height={6} width={12} variant="rectangular" />
        <SkeletonLoader height={6} width={12} variant="rectangular" />
        <SkeletonLoader height={6} width={12} variant="rectangular" />
      </div>
      <div className="ps-flex ps-flex-col ps-gap-4">
        <SkeletonLoader height={16} width={80} variant="rectangular" />
        <SkeletonLoader height={16} width={80} variant="rectangular" />
        <SkeletonLoader height={16} width={80} variant="rectangular" />
        <SkeletonLoader height={16} width={80} variant="rectangular" />
      </div>
    </div>
  );
};
